import script from "./AboutMe.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutMe.vue?vue&type=script&setup=true&lang=ts"

import "./AboutMe.vue?vue&type=style&index=0&id=1bab9a3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bab9a3d"]])

export default __exports__